import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import { BsClipboard, BsPrinterFill } from "react-icons/bs";
import { toastError, toastSuccess } from "../../../../common/Toast";
import { useParams, Link } from "react-router-dom";
import jsPdf from "jspdf";
import Select from "react-select";
import { IoMdAddCircle } from "react-icons/io";
import {
  ALREADY_EXIST,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../../common/Constant";
import config from "../../../../config/config";
import axios from "axios";
import Loader from "../../../../components/Loader/Loader";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";

const Inventory = (props) => {
  const { Listofdata, callback } = props;
  const buttonRef = React.useRef(null);
  const paramObject = useParams();
  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  const [loading, setLoading] = useState(false);
  const [invvalue, setinvvalue] = useState("");
  const [inventoryValues, setInventoryValues] = useState([]);
  console.log(inventoryValues, "410501");

  const [formValues, setFormValues] = useState({
    IReorderLevel: "",
    IReplenishLevel: "",
    DayExpiration: "",
    CurrentQuantity: "",
    DamagedQuantity: 0,
    QtyAddSub: 0,
    InventoryComments: "",
    UpdatedQuantity: 0,
  });

  const [inventroyReport, setInventroyReport] = useState({
    customer: 0,
    supplier: 0,
    inventoryTransaction: 0,
  });
  const [description, setDescription] = useState("");
  const [DataForProps, setDataForProps] = useState([]);
  const [SubmitEvent, setSubmitEvent] = useState(0);
  const [custoptions, setCustOptions] = useState([]);
  const [inventoryobject, setInventoryObject] = useState({});
  const [recoptions, setRecOptions] = useState([
    {
      Id: Number,
      CompanyName: String,
      FirstName: String,
      LastName: String,
      Email: String,
      PhoneNumber: Number,
      Address1: String,
      City: String,
      StateProvince: String,
      Zip: Number,
      Country: String,
    },
  ]);

  const [transactiondropdown, setTransactionDropdown] = useState([]);
  const [variationDropdown, setVariationDropdown] = useState([]);

  const [startingDate, setStartingDate] = useState("");
  const [endingDate, setEndingDate] = useState("");
  const [customStartingDate, setCustomStartingDate] = useState();
  const [customEndingDate, setCustomEndingDate] = useState();
  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "Current Month",
    value: 6,
  });

  const [selectVariationID, setSelectVariationID] = useState(0);
  const [selectedVariation, setSelectedVariation] = useState();
  const [isVariableSet, setIsVariableSet] = useState(true);

  const [accountquickbookid, setAccountQuickbookId] = useState(0);
  const [expensequickbookid, setExpenseQuickbookId] = useState(0);
  const [incomequickbookid, setIncomeQuickbookId] = useState(0);

  // For parameters-
  let locationId = JSON.parse(localStorage.getItem("Location")) || "";

  const handleBack = () => {
    props.previousStep();
    window.scrollTo(0, 0);
  };
  const handleSubmitForm = () => {
    setSubmitEvent(1);
  };
  const handleVariationInput = (event, index) => {
    let name, values;

    name = event.target.name;
    values = event.target.value;

    console.log(parseFloat(values).toFixed(2), "852");

    if (name == "DamegedQuantity") {
      let cardInput = [...inventoryValues];
      if (cardInput[index]) {
        cardInput[index]["DamegedQuantity"] = values;
        setInventoryValues((prevValues) => {
          const updatedValues = [...prevValues];
          updatedValues[index].DamegedQuantity = Number(values);
          updatedValues[index].UpdatedQuantity =
            Number(updatedValues[index].Quantity) - Number(values);
          updatedValues[index].InventoryAddSubtract = Number(-values);
          return updatedValues;
        });
      }
    } else if (name == "Quantity") {
      let cardInput = [...inventoryValues];
      cardInput[index]["Quantity"] = Number(values);
      cardInput[index]["InventoryAddSubtract"] = parseFloat(values);
      cardInput[index]["DamegedQuantity"] = 0;

      setInventoryValues(cardInput);
    } else if (name == "InventoryAddSubtract") {
      let cardInput = [...inventoryValues];
      cardInput[index].InventoryAddSubtract = values;
       // again
      // cardInput[index].UpdatedQuantity =
      //   Number(cardInput[index].Quantity) + Number(values);
      cardInput[index].DamegedQuantity = 0;
      setInventoryValues(cardInput);
    } else if (name == "ReorderLevel") {
      let cardInput = [...inventoryValues];
      cardInput[index][name] = values;
      setInventoryValues(cardInput);
    } else if (name == "ReplenishLevel") {
      let cardInput = [...inventoryValues];
      cardInput[index][name] = values;
      setInventoryValues(cardInput);
    } else if (name == "Comments") {
      setInventoryValues((prevValues) => {
        const updatedValues = [...prevValues];
        updatedValues[index][name] = values;
        return updatedValues;
      });
    }
  };

  const handleSearchAccordingToDate = () => {
    // handleListData(
    //   1,
    //   perPageSize,
    //   searchtext,
    //   sortingId,
    //   sortingDirection,
    //   startingDate,
    //   endingDate,
    //   receivingTypeID,
    //   supplierID,
    //   columnFilters,
    //   globalFilter,
    //   pagination,
    //   sorting,
    //   status
    // );
  };

  useEffect(() => {
    if (quickBookOptions?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    // else if (quickBookOptions?.value == 2) {
    //   setStartingDate(customStartingDate);
    //   setEndingDate(customEndingDate);
    // }
    // Last Week Condition
    else if (quickBookOptions?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (quickBookOptions?.value == 4) {
      const currentWeekStartDate = moment()
        .startOf("week")
        .format("YYYY-MM-DD");
      const currentWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");

      setStartingDate(currentWeekStartDate);
      setEndingDate(currentWeekEndDate);
    }
    // Last Month Condition
    else if (quickBookOptions?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    //current Month
    else if (quickBookOptions?.value == 6) {
      const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
      const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(currentFirstDate);
      setEndingDate(currentLastDate);
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  }, [quickBookOptions]);

  useEffect(() => {
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/accountdefaultitemaccount`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )

      .then((res) => {
        // alert(JSON.stringify(res.data))
        const accountdata = res.data?.ResponseData[0];
        const incomedata = res.data?.ResponseData[1];
        const expensedata = res.data?.ResponseData[2];
        // setAccountId(accountdata?.accountid);
        setIncomeQuickbookId(incomedata?.incomaccountQuickbookid);
        setExpenseQuickbookId(expensedata?.expenceaccountQuickbookIdid);
        setAccountQuickbookId(accountdata?.accountQuickbookid);
        // setExpenseQuickbookId(expensedata?.expenceaccountQuickbookIdid);
        // setAccountQuickbookId(accountdata?.accountQuickbookid);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleVariationFilterChange = (event) => {
    setSelectedVariation(event);
    setSelectVariationID(event?.value);
  };

  const handleQuickBookChange = (event) => {
    event?.value !== 2 && handleSearchAccordingToDate();

    setQuickBookOptions(event);

    // All Condition
    if (event?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    else if (event?.value == 2) {
      setStartingDate(customStartingDate);
      setEndingDate(customEndingDate);
    }
    // Last Week Condition
    else if (event?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (event?.value == 4) {
      const lastWeekStartDate = moment().startOf("week").format("YYYY-MM-DD");
      const lastWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Last Month Condition
    else if (event?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    // Current Month Condition
    else if (event?.value == 6) {
      const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
      const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(currentFirstDate);
      setEndingDate(currentLastDate);
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  };

  const options = [
    { label: "All", value: 1 },
    { label: "Current Week", value: 4 },
    { label: "Last Week", value: 3 },
    { label: "Current Month", value: 6 },
    { label: "Last Month", value: 5 },
    { label: "Custom", value: 2 },
  ];

  const variationDropdown1 = [
    { label: "All", value: 1 },
    { label: "Current Week", value: 4 },
    { label: "Last Week", value: 3 },
    { label: "Current Month", value: 6 },
    { label: "Last Month", value: 5 },
    { label: "Custom", value: 2 },
  ];

  const ActionButtons = (props) => {
    const handleBack = () => {
      props.previousStep();
      window.scrollTo(0, 0);
    };

    const handleNext = () => {
      props.nextStep();
      window.scrollTo(0, 0);
    };

    return (
      <div className="text-center">
        {props.currentStep > 1 && (
          <button onClick={handleBack} className="btn btn-sm btn-primary me-3">
            Back
          </button>
        )}
        {props.currentStep < props.totalSteps && (
          <button onClick={handleNext} className="btn btn-sm btn-primary">
            Next
          </button>
        )}
      </div>
    );
  };
  function handleButtonClick() {
    buttonRef.current.click();
  }

  // handleInput-
  const handleInput = (e) => {
    const { name, value } = e.target;
    if (name === "DamagedQuantity") {
      setFormValues({
        ...formValues,
        UpdatedQuantity: Number(formValues.CurrentQuantity) - Number(value),
        DamagedQuantity: Number(value),
        QtyAddSub: -Number(value),
      });
    } else if (name === "QtyAddSub") {
      setFormValues({
        ...formValues,
        UpdatedQuantity: Number(formValues.CurrentQuantity),
        QtyAddSub: Number(value),
        DamagedQuantity: 0,
      });
    }
  };
  const handleChangeinv = (e) => {
    setinvvalue(e.target.value);
  };

  const handleinvqty = () => {
    const addOtherSection = inventoryValues?.map((obj) => {
      return {
        ...obj,
        InventoryAddSubtract: invvalue ? Number(invvalue) : 0,
      };
    });

    setInventoryValues(addOtherSection);
  };

  const itemidsarray = [];

  // handlesubmit-
  const handleSubmit = async (values) => {

//     if (SubmitEvent === 1) {
//       setSubmitEvent(0);
//     } else {
//       props.nextStep();
//       window.scrollTo(0, 0);
//     }

// return





    setLoading(true);
    console.log(values, formValues, "98985");

    try {
      // Fetch inventory quantity listing
      // const res = await axios.get(
      //   `${config.itemsBaseUrl}/items/inventoryfindbyid?id=${paramObject.id}&locationid=${locationId}`,
      //   {
      //     headers: {
      //       "Content-Type": "application/json;charset=UTF-8",
      //       Authorization: token,
      //     },
      //   }
      // );

      // console.log(res.data.ResponseData.Items, 557);

      // const pastqtMap = res.data.ResponseData.Itemsvariations.reduce(
      //   (map, item) => {
      //     map[item.ItemVariationId] = parseFloat(item.Quantity);
      //     return map;
      //   },
      //   {}
      // );

      // Update inventoryValues based on the pastqtMap
      // let VariationData = inventoryValues.map((item) => {
        // const currentQuantity = pastqtMap[item.ItemVariationId] || 0;
        // const inventoryAdjustment =
        //   item.InventoryAddSubtract == ""
        //     ? 0
        //     : parseFloat(item.InventoryAddSubtract);
        // console.log(currentQuantity, "8858", inventoryAdjustment, item);

        // let qty = inventoryAdjustment.toFixed(2) - currentQuantity;
        // console.log(
        //   qty,
        //   typeof item.InventoryAddSubtract,
        //   item.InventoryAddSubtract === "",
        //   "754"
        // );

        // return {
        //   ...item,
          // InventoryAddSubtract:
          //   item.InventoryAddSubtract === ""
          //     ? currentQuantity
          //     : inventoryAdjustment.toFixed(2),
          // Quantity: item.UpdatedQuantity,
          // qbqty:
          //   item.InventoryAddSubtract === ""
          //     ? currentQuantity
          //     : inventoryAdjustment,
          // DamagedQuantity: item.DamagedQuantity,
          // Lastedqty: item.InventoryAddSubtract === "" ? 0 : qty.toFixed(2),
          // type: formValues?.type == "inventory" ? "inventory" : "",
      //   };
      // });

      let VariationData = inventoryValues;
      console.log(VariationData, 556);

      VariationData = VariationData.filter(
        (variationValue) => variationValue?.ItemVariationId !== ""
      );

      // const inventoryobj = { InventoryItemDataXML: [values] };
      const variationpricingobj = {
        InventoryItemVariationDataXML: VariationData,
      };

      // let inventoryjsonstring = JSON.stringify(inventoryobj);
      let variationpricingjsonstring = JSON.stringify(variationpricingobj);

      // let qty =
      //   values?.QtyAddSub -
      //   (res?.data?.ResponseData?.Items[0]?.Defaultquantity
      //     ? Number(res?.data?.ResponseData?.Items[0]?.Defaultquantity)
      //     : 0);

      console.log(variationpricingjsonstring, "85858");

      // console.log(qty, "876");

      try {
        const upsertRes = await axios.post(
          `${config.itemsBaseUrl}/items/inventoryupsert`,
          {
            itemid: paramObject.id || 0,
            reorderlevel: values.IReorderLevel,
            replenishlevel: values.IReplenishLevel,
            daystoexpiration: values.DayExpiration,
            // qtyaddsub:
            //   values?.QtyAddSub === ""
            //     ? res?.data?.ResponseData?.Items[0]?.Defaultquantity
            //       ? Number(
            //           res?.data?.ResponseData?.Items[0]?.Defaultquantity
            //         ).toFixed(2)
            //       : 0
            //     : values?.QtyAddSub,
            qtyaddsub: values?.QtyAddSub,
            inventorycomments: values.InventoryComments,
            xmlvariation: variationpricingjsonstring,
            loginuserid: Id,
            locationid: locationId,
            // Lastedqty:
            //   res.data.ResponseData?.Items.length > 0
            //     ? values?.QtyAddSub === ""
            //       ? 0
            //       : qty
            //       ? Number(qty).toFixed(2)
            //       : 0
            //     : 0,
            Lastedqty: 0,
            quickbookexpenseid: expensequickbookid,
            quickbookincomeid: incomequickbookid,
            quickbookinventoryassestid: accountquickbookid,
            // inventoryobject: inventoryobj,
            updatedquantity: values?.UpdatedQuantity,
            // itemquickbookid: res.data.ResponseData?.Items[0]?.QuickbookId,
            // parentquickbookidqty:
            //   res.data.ResponseData?.Items.length > 0
            //     ? values.QtyAddSub === ""
            //       ? res?.data?.ResponseData?.Items[0]?.Defaultquantity
            //         ? Number(
            //             res?.data?.ResponseData?.Items[0]?.Defaultquantity
            //           ).toFixed(2)
            //         : 0
            //       : values.QtyAddSub
            //     : 0,
            itemquickbookid:0,
            parentquickbookidqty: 0,
            currentquantity: values.CurrentQuantity,
            description: description,
            type: formValues?.type == "inventory" ? "inventory" : "",
          },
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        );

        setLoading(false);

        if (
          upsertRes.data.ResponseCode === "SUCCESS" &&
          upsertRes.data.ResponseID > 0
        ) {
          toastSuccess(SUCCESS_MESSAGE);
        } else if (
          upsertRes.data.ResponseCode === "ERROR" &&
          upsertRes.data.ResponseID === -1
        ) {
          toastError("Name" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
      } catch (error) {
        // Handle the error here, for example by logging it or showing a message to the user
        console.error("Error occurred while upserting inventory:", error);
        // You can also provide user feedback
        // alert(
        //   "An error occurred while updating the inventory. Please try again."
        // );
      }

      // // Fetch updated data
      // const rackRes = await axios.get(
      //   `${config.itemsBaseUrl}/items/itemsrackselectbyid?ItemId=${paramObject.id}`,
      //   {
      //     headers: {
      //       "Content-Type": "application/json;charset=UTF-8",
      //       Authorization: token,
      //     },
      //   }
      // );

      // setDataForProps(rackRes.data.ResponseData);
      // callback(rackRes.data.ResponseData);

      if (SubmitEvent === 1) {
        setSubmitEvent(0);
      } else {
        props.nextStep();
        window.scrollTo(0, 0);
      }
    } catch (error) {
      console.log("error: ", error);
      setLoading(false);
    }
  };

  const handleaddInventory = async () => {
    setFormValues({
      ...formValues,
      type: "inventory",
    });

    setSubmitEvent(1);
    // try {
    //   const res = await axios.get(
    //     `${config.itemsBaseUrl}/items/inventoryfindbyid?id=${paramObject.id}&locationid=${locationId}`,
    //     {
    //       headers: {
    //         "Content-Type": "application/json;charset=UTF-8",
    //         Authorization: token,
    //       },
    //     }
    //   );

    //   console.log(res.data.ResponseData, 557);

    //   const pastqtMap = res.data.ResponseData.Itemsvariations.reduce(
    //     (map, item) => {
    //       map[item.ItemVariationId] = parseFloat(item.Quantity);
    //       return map;
    //     },
    //     {}
    //   );

    //   // Update inventoryValues based on the pastqtMap
    //   let VariationData = inventoryValues.map((item) => {
    //     const currentQuantity = pastqtMap[item.ItemVariationId] || 0;
    //     const inventoryAdjustment = parseFloat(item.InventoryAddSubtract);
    //     let qty = inventoryAdjustment.toFixed(2) - currentQuantity;
    //     console.log(currentQuantity, "8858");

    //     return {
    //       ...item,
    //       InventoryAddSubtract:
    //         inventoryAdjustment == 0
    //           ? currentQuantity
    //           : inventoryAdjustment.toFixed(2),
    //       Quantity: item.UpdatedQuantity,
    //       qbqty:
    //         inventoryAdjustment !== 0 ? inventoryAdjustment : currentQuantity,
    //       DamagedQuantity: item.DamagedQuantity,
    //       Lastedqty: inventoryAdjustment == 0 ? 0 : qty.toFixed(2),
    //     };
    //   });
    //   console.log(VariationData, 556);

    //   VariationData = VariationData.filter(
    //     (variationValue) => variationValue.ItemVariationId !== ""
    //   );

    //   // const inventoryobj = { InventoryItemDataXML: [values] };
    //   const variationpricingobj = {
    //     InventoryItemVariationDataXML: VariationData,
    //   };

    //   // let inventoryjsonstring = JSON.stringify(inventoryobj);
    //   let variationpricingjsonstring = JSON.stringify(variationpricingobj);

    //   // Post inventory upsert
    //   setLoading(true);
    //   const upsertRes = await axios.post(
    //     `${config.itemsBaseUrl}/items/newinventoryupsert`,
    //     {
    //       itemid: paramObject.id || 0,
    //       // reorderlevel: values.IReorderLevel,
    //       // replenishlevel: values.IReplenishLevel,
    //       // daystoexpiration: values.DayExpiration,
    //       // qtyaddsub: values.QtyAddSub,
    //       // inventorycomments: values.InventoryComments,
    //       xmlvariation: variationpricingjsonstring,
    //       loginuserid: Id,
    //       locationid: locationId,
    //       Lastedqty:
    //         res.data.ResponseData?.length > 0
    //           ? res.data.ResponseData.Itemsvariations[0].Quantity
    //           : 0,
    //       quickbookexpenseid: expensequickbookid,
    //       quickbookincomeid: incomequickbookid,
    //       quickbookinventoryassestid: accountquickbookid,
    //       // inventoryobject: inventoryobj,
    //       //updatedquantity: values.UpdatedQuantity,
    //       // parentquickbookidqty:
    //       //   res.data.ResponseData?.length > 0
    //       //     ? res.data.ResponseData[0].ItemVariationId > 0
    //       //       ? 0
    //       //       : Number(res.data.ResponseData[0].CurrentQuantity) +
    //       //         Number(values.QtyAddSub)
    //       //     : Number(values.QtyAddSub),
    //       // currentquantity: values.CurrentQuantity,
    //       description: description,
    //     },
    //     {
    //       headers: {
    //         "Content-Type": "application/json;charset=UTF-8",
    //         Authorization: token,
    //       },
    //     }
    //   );
    //   console.log(upsertRes, "5987");
    //   setLoading(false);

    //   toastSuccess(upsertRes?.data);
    // } catch (error) {
    //   console.log(error);
    //   setLoading(false);
    // }
  };

  // Dropdowns
  const customerDropDown = custoptions.map((option) => ({
    value: option.Id,
    label: option.CompanyName,
    //  + "(" + option.FirstName + " " + option.LastName + ")"
    address: option.Address1,
    email: option.Email,
  }));

  const supplierDropDown = recoptions.map((option) => ({
    value: option.ID,
    label: option.CompanyName, // option.FirstName + " " + option.LastName,
    //  + "(" + option.FirstName + " " + option.LastName + ")"
    address: option.Address,
  }));

  const inventorydropdown = transactiondropdown.map((option) => ({
    value: option.ID,
    label: option.Type,
  }));

  const handleChangeCustomer = (e) => {
    console.log(e?.value, "handleChangeCustomer");
    setInventroyReport({ ...inventroyReport, customer: e?.value });
  };

  // const handleChangeCustomStartingDate = (event) => {
  //   console.log("event starting ==> ", event.target.value);
  //   setCustomStartingDate(event.target.value);
  //   setStartingDate(event.target.value);
  // };

  const handleChangeCustomStartingDate = (selectedDate) => {
    if (selectedDate && selectedDate.length > 0) {
      const datetime =
        moment(selectedDate[0]).format("YYYY-MM-DDT00:00:00.000") + "Z";
      const settime = moment(datetime).format("YYYY-MM-DD");
      console.log(settime, "settime");
      setCustomStartingDate(settime);
      setStartingDate(settime);
    }
  };

  // const handleChangeCustomEndingDate = (event) => {
  //   // console.log("event ending ==> ", event.target.value);
  //   setCustomEndingDate(event.target.value);
  //   setEndingDate(event.target.value);
  // };

  const handleChangeCustomEndingDate = (selectedDate) => {
    if (selectedDate && selectedDate.length > 0) {
      const datetime =
        moment(selectedDate[0]).format("YYYY-MM-DDT00:00:00.000") + "Z";
      const settime = moment(datetime).format("YYYY-MM-DD");
      console.log(settime, "settime");
      setCustomEndingDate(settime);
      setEndingDate(settime);
    }
  };

  const handleChangeSupplier = (e) => {
    setInventroyReport({ ...inventroyReport, supplier: e?.value });
  };

  const handleChangeInventoryTransaction = (e) => {
    setInventroyReport({ ...inventroyReport, inventoryTransaction: e?.value });
  };

  const [itemsInventory, setItemsInventory] = useState([]);

  console.log(itemsInventory, "itemsInventory==>");

  useEffect(() => {
    console.log(paramObject.id, "paramObject==>");
    if (paramObject.id > 0) {
      axios
        .get(
          `${config.itemsBaseUrl}/items/inventoryfindbyid?id=${paramObject.id}&locationid=${locationId}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          setLoading(false);
          console.log(
            "res.data.ResponseData.Itemsvariations 229",
            res.data.ResponseData.Itemsvariations
          );
          const items = res.data.ResponseData.Items[0];
          setDescription(items.description);
          setInventoryValues(res.data.ResponseData.Itemsvariations);
          setInventoryObject({
            itemquickbookid: items?.QuickbookId,
            costprice: items?.Costprice,
            unitprice: items?.Unitprice,
            name: items?.Name,
            sku: items?.Itemnumber,
            incomequickbookid: items?.incomequickbookid,
            expensequickbookid: items?.expensequickbookid,
            inventoryassestaccountid: items?.inventoryassestaccountid,
            categoryquickbookid: items?.categoryquickbookid,
            supplierquickbookid: items?.supplierquickbookid,
          });

          const bindingData = {
            IReorderLevel:
              parseFloat(res.data.ResponseData.Items[0].Reorderlevel) > 0
                ? parseFloat(res.data.ResponseData.Items[0].Reorderlevel)
                : 0,
            IReplenishLevel:
              parseFloat(res.data.ResponseData.Items[0].Replenishlevel) > 0
                ? parseFloat(res.data.ResponseData.Items[0].Replenishlevel)
                : 0,
            DayExpiration:
              parseFloat(res.data.ResponseData.Items[0].Expiredays) > 0
                ? parseFloat(res.data.ResponseData.Items[0].Expiredays)
                : 0,
            CurrentQuantity: res.data.ResponseData?.Items[0]?.Defaultquantity
              ? parseFloat(res.data.ResponseData?.Items[0]?.Defaultquantity)
              : 0,
            // parseFloat(res.data.ResponseData?.Items[0]?.Defaultquantity) > 0
            //   ? parseFloat(res.data.ResponseData?.Items[0]?.Defaultquantity)
            //   : 0,
            DamagedQuantity: "",
            QtyAddSub: "",
            InventoryComments:
              res.data.ResponseData?.Itemsinventory[0]?.Comment,
          };

          console.log(
            "res.data.ResponseData?.Itemsinventory[0]?.Comment",
            res.data.ResponseData?.Itemsinventory[0]?.Comment
          );
          setFormValues(bindingData);
        })
        .catch((err) => {
          setLoading(false);
          console.log("err: ", err);
        });
    }
  }, [props]);

  console.log(inventoryValues, "inventoryvalues===>");

  // useEffect(() => {
  //   setLoading(true);
  //   axios
  //     .get(
  //       `${config.itemsBaseUrl}/items/inventoryquantitylisting?ItemID=${
  //         paramObject.id
  //       }&Locationid=${locationId}&SupplierId=${
  //         inventroyReport.supplier === undefined ? 0 : inventroyReport.supplier
  //       }&CustomerId=${
  //         inventroyReport.customer === undefined ? 0 : inventroyReport.customer
  //       }&TransactionType=${
  //         inventroyReport.inventoryTransaction === undefined
  //           ? 0
  //           : inventroyReport.inventoryTransaction
  //       }&startDate=${startingDate}&endDate=${endingDate}&variation=${
  //         selectVariationID === undefined ? 0 : selectVariationID
  //       }`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       setLoading(false);
  //       setItemsInventory(res.data.ResponseData);
  //       if (isVariableSet) {
  //         const uniqueItemVariationIds = Array.from(
  //           new Set(res.data.ResponseData.map((item) => item.ItemVariationId))
  //         ).map((id) => {
  //           const matchingItem = res.data.ResponseData.find(
  //             (item) => item.ItemVariationId === id
  //           );
  //           return {
  //             label: matchingItem.ItemVariationName,
  //             value: matchingItem.ItemVariationId,
  //           };
  //         });

  //         res.data.ResponseData?.map((el) => {
  //           itemidsarray.push(
  //             Number(el.ItemVariationId) > 0
  //               ? Number(el.ItemVariationId)
  //               : Number(paramObject.id)
  //           );
  //         });

  //         setVariationDropdown(uniqueItemVariationIds);
  //         setIsVariableSet(false);
  //       }
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //       console.log("err: ", err);
  //     });
  // }, [props, inventroyReport, startingDate, endingDate, selectVariationID]);

  useEffect(() => {
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        setCustOptions(response.data.ResponseData);
        console.log(response.data.ResponseData, "===> setCustOptions");
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        console.log("supplyer list", response.data.ResponseData);
        setRecOptions(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(`${config.itemsBaseUrl}/items/inventorytransaction`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        console.log("supplyer list", response.data.ResponseData);
        setTransactionDropdown(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // Print Report-
  const handleDownload = () => {
    setLoading(true);
    var doc = new jsPdf("p", "pt", "a4");

    let content = "";
    let startIndex = 1;
    let endIndex = 30;

    for (var i = 1; i <= Math.ceil(itemsInventory.length / 30); i++) {
      if (i == 1) {
        content +=
          '<div style="width: 580px; margin-top: 1rem; margin-right: 1rem; text-align: right; font-size: 7px; font-weight: bold">Page' +
          i +
          "/" +
          Math.ceil(itemsInventory.length / 30) +
          "</div>";
      } else {
        content +=
          '<div style="width: 580px; margin-top: 2.4rem; margin-right: 1rem; text-align: right; font-size: 7px; font-weight: bold">Page' +
          i +
          "/" +
          Math.ceil(itemsInventory.length / 30) +
          "</div>";
      }

      content +=
        '<div style="width: 580px; margin-right: 1rem; margin-left: 1rem; margin-top: 0rem; margin-bottom: 0rem"><p style="font-weight: bold; font-size: 7px">Reports - RLD Detailed Inventory Report Detailed Inventory Report - 01/01/2023-12/31/2023 - 1 results found, Generation Date 08/05/2023 01:54 am ' +
        "<p></div>";

      // Printing table body-
      content +=
        '<table style="font-size: 7px; margin: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 8px;">Sr No.</th>' +
        '<th style="padding: 8px;">Inventory Data Tracking</th>' +
        '<th style="padding: 8px; width: 300px">Variation</th>' +
        '<th style="padding: 8px;">In / Out Qty</th>' +
        '<th style="padding: 8px;">	Type</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (let index = startIndex; index <= endIndex; index++) {
        if (index >= startIndex && index <= itemsInventory.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            index +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            new Date(
              itemsInventory[index - 1].InvoiceDate
            ).toLocaleDateString() +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            itemsInventory[index - 1].Name +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            Number(itemsInventory[index - 1].Quantitypurchased).toFixed(2) +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            itemsInventory[index - 1].Type +
            "</td>" +
            "</tr>";
        }

        if (index % 30 == 0) {
          startIndex = startIndex + 30;
          endIndex = endIndex + 30;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";
    }

    // Printing page-
    doc.html(content, {
      callback: function (pdf) {
        pdf.save(`pdf.pdf`);
        setLoading(false);
      },
    });
  };

  return (
    <>
      <Loader loading={loading} />
      <div className="card card-body">
        <div className="card-header d-flex justify-content-between align-items-center p-2">
          <h5 className="card-title">
            <BsClipboard className="me-1 " />
            Inventory (Fields in red are required)
          </h5>
          <div>
            {props.currentStep > 1 && (
              <button
                onClick={handleBack}
                className="btn btn-sm btn-secondary btn-md me-1"
              >
                Back
              </button>
            )}
            {props.currentStep < props.totalSteps && (
              <button
                //onClick={handleNext}
                className="btn btn-sm btn-secondary btn-md"
                type="button"
                onClick={handleButtonClick}
              >
                Next
              </button>
            )}
            {/* <button
              type="button"
              onClick={handleaddInventory}
              className="btn btn-sm btn-secondary me-3 "
              style={{ margin: "10px" }}
            >
              Sync Inventory
            </button> */}
          </div>
        </div>

        <div className="card-body">
          {" "}
          <Formik
            {...props}
            initialValues={formValues}
            // validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize
          >
            {({ errors, touched, handleChange }) => (
              <Form className="row">
                <div className="col-md-2 mb-3">
                  <label className="form-label col-form-label p-lg-medium">
                    Reorder Level
                  </label>
                </div>
                <div className="col-md-2 mb-3 mt-1">
                  <Field
                    type="text"
                    className="form-control form-control-sm"
                    id="IReorderLevel"
                    name="IReorderLevel"
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-2 mb-3">
                  <label className="form-label col-form-label p-lg-medium">
                    Replenish Level
                  </label>
                </div>
                <div className="col-md-2 mb-3 mt-1">
                  <Field
                    type="text"
                    className="form-control form-control-sm"
                    id="IReplenishLevel"
                    name="IReplenishLevel"
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-2 mb-3">
                  <label className="form-label col-form-label p-lg-medium">
                    Days To Expiration
                  </label>
                </div>
                <div className="col-md-2 mb-3 mt-1">
                  <Field
                    type="text"
                    className="form-control form-control-sm"
                    id="DayExpiration"
                    name="DayExpiration"
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-2 mb-3">
                  <label className="form-label col-form-label p-lg-medium">
                    Inventory Adjustment
                  </label>
                </div>
                <div className="col-md-2 mb-3 ">
                  <Field
                    className="form-control form-control-sm"
                    value={invvalue}
                    onChange={handleChangeinv}
                    type="number"
                    disabled
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <button
                    type="button"
                    className="btn-third"
                    onClick={handleinvqty}
                  >
                    <IoMdAddCircle /> Apply this Qty for all Variations
                  </button>
                </div>

                {/* For hide and show */}
                {inventoryValues?.length <= 0 && (
                  <>
                    <div className="col-md-2 mb-3">
                      <label className="form-label col-form-label p-lg-medium">
                        Current Quantity
                      </label>
                    </div>
                    <div className="col-md-2 mb-3">
                      <Field
                        type="number"
                        className="form-control form-control-sm"
                        id="CurrentQuantity"
                        name="CurrentQuantity"
                        onChange={handleChange}
                        onInput={(e) => handleInput(e)}
                        // value={formValues?.UpdatedQuantity || formValues?.CurrentQuantity}
                        value={
                          !formValues?.UpdatedQuantity &&
                          formValues?.UpdatedQuantity !== 0
                            ? formValues?.CurrentQuantity
                            : formValues?.UpdatedQuantity
                        }
                        disabled
                      />
                    </div>

                    <div className="col-md-2 mb-3 ">
                      <label className="form-label col-form-label p-lg-medium">
                        Damaged Qty
                      </label>
                    </div>
                    <div className="col-md-2 mb-3 ">
                      <Field
                        type="number"
                        className="form-control form-control-sm"
                        id="DamagedQuantity"
                        name="DamagedQuantity"
                        onChange={handleChange}
                        onInput={(e) => handleInput(e)}
                        disabled
                      />
                    </div>
                    <div className="col-md-2 mb-3 ">
                      <label className="form-label col-form-label p-lg-medium">
                        New Inventory
                      </label>
                    </div>
                    <div className="col-md-2 mb-3">
                      <Field
                        type="number"
                        className="form-control form-control-sm"
                        id="QtyAddSub"
                        name="QtyAddSub"
                        onChange={handleChange}
                        onInput={(e) => handleInput(e)}
                        disabled
                      />
                    </div>
                    <div className="col-md-2 mb-3   ">
                      <label className="form-label col-form-label p-lg-medium">
                        Comments
                      </label>
                    </div>
                    <div className="col-md-4 mb-3 ">
                      <textarea
                        name="InventoryComments"
                        cols="17"
                        rows="3"
                        id="InventoryComments"
                        className="form-control form-control-sm text-area"
                        defaultValue={formValues.InventoryComments}
                        onChange={handleChange}
                      ></textarea>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label me-5 col-form-label p-lg-medium">
                        Suspended Inventory:{" "}
                      </label>
                      Not Set
                    </div>
                  </>
                )}

                {/* Variation for the particular Item Id */}
                {inventoryValues?.length > 0 === true && (
                  <>
                    <h5 className="form-check-label mt-1 mb-1 fw-bold">
                      Item Variations:
                    </h5>
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Supplier</th>
                            <th>Name</th>
                            <th>Item Attributes</th>
                            <th>Item Number</th>
                            <th>Reorder Level</th>
                            <th>Replenish Level</th>
                            {/* <th>Quantity</th> */}
                            <th>Quantity</th>
                            <th>Damaged Qty</th>
                            <th>Damaged Reason</th>
                            <th>New Inventory</th>
                            <th>Comments</th>
                          </tr>
                        </thead>

                        <tbody>
                          {inventoryValues?.map((u, variationIndex) => (
                            <tr key={variationIndex}>
                              <td>{u.SupplierName}</td>
                              <td className="word-break-data">
                                {u.VariationName}
                              </td>
                              <td className="word-break-data">
                                {u.AttributeName}
                              </td>
                              <td>{u.ItemNumber}</td>
                              {/* Reorder Level */}
                              <td>
                                <Field
                                  style={{ width: "100px" }}
                                  type="number"
                                  className="form-control form-control-sm"
                                  id={`VariationReorderLevel-${variationIndex}`}
                                  name={`ReorderLevel`}
                                  value={parseFloat(u.ReorderLevel)}
                                  onChange={(event) => {
                                    handleVariationInput(event, variationIndex);
                                  }}
                                />
                              </td>

                              {/* Replenish Level */}
                              <td>
                                <Field
                                  type="number"
                                  style={{ width: "100px" }}
                                  className="form-control form-control-sm"
                                  id={`VariationReplenishLevel-${variationIndex}`}
                                  name={`ReplenishLevel`}
                                  value={parseFloat(u.ReplenishLevel)}
                                  onChange={(event) => {
                                    handleVariationInput(event, variationIndex);
                                  }}
                                />
                              </td>

                              {/* Quantity */}
                              {/* <td>
                                <Field
                                  type="number"
                                  className="form-control"
                                  id={`VariationQuantity-${variationIndex}`}
                                  name={`Quantity`}
                                  defaultvalue={parseFloat(u.Quantity)}
                                  value={parseFloat(u.Quantity)}
                                  disabled
                                  onChange={(event) => {
                                    handleVariationInput(event, variationIndex);
                                  }}
                                />
                              </td> */}

                              {/* In Real Updated Quantity But we are using as Quantity */}
                              <td>
                                <Field
                                  style={{ width: "100px" }}
                                  type="number"
                                  className="form-control form-control-sm"
                                  id={`VariationQuantity-${variationIndex}`}
                                  name={`UpdatedQuantity`}
                                  // defaultvalue={parseFloat(u.UpdatedQuantity)}
                                  value={
                                    !parseFloat(u.UpdatedQuantity) &&
                                    parseFloat(u.UpdatedQuantity) !== 0
                                      ? parseFloat(u.Quantity).toFixed(2)
                                      : parseFloat(u.UpdatedQuantity).toFixed(2)
                                  }
                                  disabled
                                  onChange={(event) => {
                                    handleVariationInput(event, variationIndex);
                                  }}
                                />
                              </td>

                              {/* Damaged Quantity */}
                              <td>
                                <Field
                                  type="number"
                                  style={{ width: "100px" }}
                                  className="form-control form-control-sm"
                                  id={`DamegedQuantity-${variationIndex}`}
                                  name={`DamegedQuantity`}
                                  value={
                                    parseFloat(u.DamegedQuantity) === 0
                                      ? ""
                                      : parseFloat(u.DamegedQuantity)
                                  }
                                  onChange={(event) => {
                                    handleVariationInput(event, variationIndex);
                                  }}
                                  disabled
                                />
                              </td>

                              {/* Damaged Reason */}
                              <td>
                                <Field
                                  type="text"
                                  style={{ width: "100px" }}
                                  className="form-control form-control-sm"
                                  id={`DamagedReason-${variationIndex}`}
                                  name={`DamagedReason`}
                                  // value={u.DamagedReason}
                                  onChange={(event) => {
                                    handleVariationInput(event, variationIndex);
                                  }}
                                  disabled
                                />
                              </td>

                              {/* Inventory to add/subtract */}
                              <td>
                                <Field
                                  type="number"
                                  style={{ width: "100px" }}
                                  className="form-control form-control-sm"
                                  id={`InventoryAddSubtract-${variationIndex}`}
                                  name={`InventoryAddSubtract`}
                                  value={
                                    u.InventoryAddSubtract
                                    // parseFloat(u.InventoryAddSubtract) === 0
                                    //   ? ""
                                    //   : parseFloat(u.InventoryAddSubtract)
                                  }
                                  onChange={(event) => {
                                    handleVariationInput(event, variationIndex);
                                  }}
                                  disabled
                                />
                              </td>

                              {/* Comments */}
                              <td>
                                <p>{u.Comments}</p>
                                <Field
                                  type="text"
                                  className="form-control form-control-sm"
                                  id={`Comments-${variationIndex}`}
                                  name="Comments"
                                  value={u.Comments}
                                  onChange={(event) => {
                                    handleVariationInput(event, variationIndex);
                                  }}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}

                {/* Next and Back Button */}
                <div className="text-center mb-4 mt-4">
                  {props.currentStep > 1 && (
                    <button
                      type="button"
                      onClick={handleBack}
                      className="btn btn-sm btn-secondary me-3"
                    >
                      Back
                    </button>
                  )}
                  {props.currentStep < props.totalSteps && (
                    <button
                      type="submit"
                      className="btn btn-sm btn-secondary me-3"
                      ref={buttonRef}
                    >
                      Next
                    </button>
                  )}
                  <button
                    onClick={handleSubmitForm}
                    className="btn btn-sm btn-primary btn-md me-3"
                    id="btn_submit"
                    type="submit"
                  >
                    Save
                  </button>
                  <button
                    id="btn_submit"
                    type="submit"
                    onClick={handleaddInventory}
                    className="btn btn-sm btn-secondary me-3 "
                  >
                    Sync Inventory
                  </button>
                  <Link to="/items" className="btn btn-sm btn-secondary btn-md">
                    Cancel
                  </Link>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>

      {/* Report */}
      {/* comment for hide item inventory log */}
      {false && (
        <div className="card">
          <div className="card-body">
            {/* <div className="row">
            <div className="col-md-4 mb-3 mt-5">
              <button type="button" className="btn btn-primary">
                View Report [Last 7 Days]
              </button>
            </div>
            <div className="col-md-4 mb-3 mt-5">
              <button type="button" className="btn btn-primary ">
                View Report [Last 30 Days]
              </button>
            </div>
            <div className="col-md-4 mb-3 mt-5">
              <button type="button" className="btn btn-primary ">
                View Report [This Year]
              </button>
            </div>
          </div> */}
            <div className="row">
              <div className="pr-2 col-lg-2 col-md-5 col-sm-12">
                Date Filter:
                <Select
                  defaultValue={quickBookOptions}
                  onChange={(event) => {
                    handleQuickBookChange(event);
                  }}
                  options={options}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  // isClearable={true}
                  // hideSelectedOptions={true}
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  className="custom-search-select"
                />
              </div>

              {quickBookOptions?.value == 2 && (
                <>
                  <div className="pr-2 col-lg-2 col-md-6 col-sm-12">
                    Custom Start Date:
                    <Flatpickr
                      type="date"
                      className="form-control form-control-sm mt-1"
                      id="StartDate"
                      name="StartDate"
                      value={
                        moment(customStartingDate).format(
                          "YYYY-MM-DDT00:00:00.000"
                        ) + "Z"
                      }
                      onChange={(event) =>
                        handleChangeCustomStartingDate(event)
                      }
                      options={{
                        dateFormat: "m/d/Y",
                        altInput: true,
                        altFormat: "m/d/Y",
                      }}
                    />
                  </div>
                  <div className="pr-2 col-lg-2 col-md-6 col-sm-12">
                    Custom End Date:
                    <Flatpickr
                      type="date"
                      className="form-control form-control-sm mt-1"
                      id="EndDate"
                      name="EndDate"
                      value={
                        moment(customEndingDate).format(
                          "YYYY-MM-DDT00:00:00.000"
                        ) + "Z"
                      }
                      onChange={(event) => handleChangeCustomEndingDate(event)}
                      options={{
                        dateFormat: "m/d/Y",
                        altInput: true,
                        altFormat: "m/d/Y",
                      }}
                    />
                  </div>
                  {/* <div className="pr-2 col-lg-1 col-md-6 col-sm-12 mt-4">
                  <button
                    className="btn btn-dark btn-sm"
                    onClick={() => handleSearchAccordingToDate()}
                  >
                    {" "}
                    Search{" "}
                  </button>
                </div> */}
                </>
              )}
              <div className="pr-2 col-lg-2 col-md-5 col-sm-12 mt-2">
                Variation Filter:
                <Select
                  defaultValue={selectedVariation}
                  onChange={(event) => {
                    handleVariationFilterChange(event);
                  }}
                  options={variationDropdown}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  isClearable={true}
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  className="custom-search-select"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 mb-3 col-form-label p-lg-medium">
                Customer:
                <Select
                  onChange={handleChangeCustomer}
                  options={customerDropDown}
                  backspaceRemovesValue={true}
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  controlShouldRenderValue={true}
                  isClearable={true}
                  id="customer"
                  name="customer"
                  className="custom-search-select"
                />
              </div>

              {/* inventorytransaction */}
              <div className="col-md-4 mb-3 col-form-label p-lg-medium">
                Supplier:
                <Select
                  // defaultValue={supplierValue}
                  onChange={(event) => {
                    handleChangeSupplier(event);
                  }}
                  options={supplierDropDown}
                  backspaceRemovesValue={false}
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  controlShouldRenderValue={true}
                  isClearable={true}
                  className="custom-search-select"
                />
              </div>
              {/* inventorytransaction */}
              <div className="col-md-4 mb-3 col-form-label p-lg-medium">
                Transaction:
                <Select
                  // defaultValue={supplierValue}
                  onChange={(event) => {
                    handleChangeInventoryTransaction(event);
                  }}
                  options={inventorydropdown}
                  backspaceRemovesValue={false}
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  controlShouldRenderValue={true}
                  isClearable={true}
                  className="custom-search-select"
                />
              </div>
            </div>
            <div className="col-md-12 mb-3 mt-3">
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th className="p-regular">Date</th>
                      <th className="p-regular ">Item Variation</th>
                      <th className="p-regular">In/Out Qty</th>
                      <th className="p-regular">Quantity Onhand</th>
                      <th className="p-regular">Balance</th>
                      <th className="p-regular">Type</th>
                      <th className="p-regular">Reference</th>
                      <th className="p-regular">Comment</th>
                      {/* <th>Supplier/Customer</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {itemsInventory.length > 0 ? (
                      itemsInventory.map((item, index) => (
                        <tr key={index}>
                          <td>
                            {new Date(
                              item.TransactionDate
                            ).toLocaleDateString()}
                          </td>
                          <td className="word-break-data">{item?.Name}</td>
                          <td style={{ textAlign: "left" }}>
                            {Number(item?.InventoryAddSubtraction).toFixed(2)}
                          </td>
                          <td style={{ textAlign: "left" }}>
                            {Number(item?.PastQuanitity).toFixed(2)}
                          </td>
                          <td style={{ textAlign: "left" }}>
                            {Number(item?.CurrentQuantity).toFixed(2)}
                          </td>
                          <td> {item?.TransactionType}</td>
                          <td className="word-break-data">
                            {" "}
                            {item?.RefrenceNo}
                          </td>
                          <td> {item?.Comment}</td>
                          {/* <td> {item?.CompanyName}</td> */}
                        </tr>
                      ))
                    ) : (
                      <tr style={{ textAlign: "center", columnSpan: 6 }}>
                        <td>No Data</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* <div className="col-md-12 align-center mb-2 mt-1">
        <button className="btn btn-sm btn-secondary" onClick={handleDownload}>
          <BsPrinterFill className="me-1" />
          Print
        </button>
      </div> */}
    </>
  );
};

export default Inventory;
